/**
 * Fabpad cart drawer — AJAX cart, Section Rendering API refresh.
 * Checkout uses native <a href="/checkout"> only (Magic Checkout / Shopflo compatible).
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var sectionId = drawer.dataset.sectionId;
  var configEl = document.querySelector('[data-cart-config]');
  var config = configEl ? JSON.parse(configEl.textContent) : {};
  var threshold = parseInt(drawer.dataset.threshold, 10) || config.threshold || 49900;
  var panel = drawer.querySelector('[data-cart-panel]');
  var inner = drawer.querySelector('[data-cart-drawer-inner]');
  var lastFocus = null;
  var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var RECENT_UNDERWEAR_KEY = 'fabpad-recent-underwear';

  function formatMoney(cents) {
    var value = Number(cents) || 0;
    var amount = (Math.abs(value) / 100).toFixed(2);
    var format = config.moneyFormat || (window.Shopify && Shopify.money_format) || '₹{{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Math.abs(value) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function isUnderwearHandle(handle) {
    var h = String(handle || '').toLowerCase();
    if (!h) return false;
    if (
      h.indexOf('detergent') !== -1 ||
      h.indexOf('intimate-wash') !== -1 ||
      h.indexOf('intimate-wipes') !== -1 ||
      h.indexOf('pantyliner') !== -1 ||
      h.indexOf('panty-liner') !== -1 ||
      h.indexOf('sanitary') !== -1 ||
      h.indexOf('cloth-pad') !== -1 ||
      h.indexOf('menstrual-cup') !== -1 ||
      h.indexOf('steriliz') !== -1 ||
      h.indexOf('tampon') !== -1
    ) {
      return false;
    }
    return (
      h.indexOf('period-pant') !== -1 ||
      h.indexOf('underwear') !== -1 ||
      h.indexOf('high-waist') !== -1 ||
      h.indexOf('shortie') !== -1 ||
      h.indexOf('shorty') !== -1 ||
      h.indexOf('bonded') !== -1 ||
      h.indexOf('reusable-period') !== -1
    );
  }

  function underwearLabel(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('teen') !== -1) return 'Teen';
    if (h.indexOf('bonded') !== -1) return 'Bonded';
    if (h.indexOf('shortie') !== -1 || h.indexOf('shorty') !== -1) return 'Shorties';
    if (h.indexOf('high-waist') !== -1 || h.indexOf('high_waist') !== -1) return 'High waist';
    return 'Mid waist';
  }

  function readRecentUnderwear() {
    try {
      var raw = window.localStorage.getItem(RECENT_UNDERWEAR_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (err) {
      return [];
    }
  }

  function recordViewedUnderwear() {
    var el = document.querySelector('[data-fabpad-viewed-product]');
    if (!el) return;
    try {
      var viewed = JSON.parse(el.textContent);
      var handle = viewed && viewed.handle;
      if (!isUnderwearHandle(handle)) return;
      var list = readRecentUnderwear().filter(function (item) {
        return item !== handle;
      });
      list.unshift(handle);
      window.localStorage.setItem(RECENT_UNDERWEAR_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (err) {
      /* ignore storage errors */
    }
  }

  function productImageSrc(product) {
    if (!product) return '';
    var src = product.featured_image;
    if (!src && product.images && product.images.length) src = product.images[0];
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function syncFbtAddAll() {
    if (!inner) return;
    var wrap = inner.querySelector('[data-cross-sell]');
    if (!wrap) return;
    var addAll = wrap.querySelector('[data-fbt-add-all]');
    var buttons = wrap.querySelectorAll('[data-cross-sell-add]');
    var ids = [];
    var total = 0;
    buttons.forEach(function (btn) {
      var id = parseInt(btn.dataset.variantId, 10);
      if (id) ids.push(id);
      var row = btn.closest('[data-cross-sell-card]');
      if (row) total += parseInt(row.dataset.price, 10) || 0;
    });
    if (!addAll) return;
    addAll.dataset.variantIds = ids.join(',');
    if (ids.length > 1) {
      addAll.hidden = false;
      addAll.textContent = (ids.length > 2 ? 'Add all' : 'Add both') + ' · ' + formatMoney(total);
    } else {
      addAll.hidden = true;
    }
  }

  function personalizeFbtUnderwear(cart) {
    if (!inner) return;
    var slot = inner.querySelector('[data-fbt-role="underwear"]');
    if (!slot) return;

    var cartHandles = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (item && item.handle) cartHandles[item.handle] = true;
    });

    var current = slot.dataset.productHandle || '';
    var pick = '';
    readRecentUnderwear().some(function (handle) {
      if (!handle || cartHandles[handle]) return false;
      pick = handle;
      return true;
    });

    if (!pick || pick === current) return;

    fetch(root + 'products/' + encodeURIComponent(pick) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Underwear lookup failed');
        return res.json();
      })
      .then(function (product) {
        if (!product || !product.handle) return;
        var variant = (product.variants || []).find(function (item) {
          return item && item.available;
        });
        if (!variant && product.variants && product.variants.length) {
          variant = product.variants[0];
        }
        if (!variant) return;

        slot.dataset.productHandle = product.handle;
        slot.dataset.price = String(variant.price);

        var pdpLink = slot.querySelector('[data-fbt-pdp]');
        if (pdpLink) {
          pdpLink.href = root + 'products/' + encodeURIComponent(product.handle);
          pdpLink.setAttribute('aria-label', 'View ' + underwearLabel(product.handle));
        }

        var titleEl = slot.querySelector('.cart-drawer__fbt-title');
        if (titleEl) titleEl.textContent = underwearLabel(product.handle);

        var priceEl = slot.querySelector('.cart-drawer__fbt-price');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        var img = slot.querySelector('.cart-drawer__fbt-image');
        var src = productImageSrc(product);
        if (img && src) {
          img.src = src;
          img.alt = underwearLabel(product.handle);
        }

        var addBtn = slot.querySelector('[data-cross-sell-add]');
        if (addBtn) addBtn.dataset.variantId = String(variant.id);

        syncFbtAddAll();
      })
      .catch(function () {
        /* keep Liquid fallback */
      });
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function trapCartWheel(e) {
    if (!drawer.classList.contains('is-open')) return;
    var scroller = drawer.querySelector('[data-cart-scroll-body]');
    if (scroller) {
      scroller.scrollTop += e.deltaY;
    }
    e.preventDefault();
    e.stopPropagation();
  }

  if (panel) {
    panel.addEventListener('wheel', trapCartWheel, { passive: false });
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = getFocusable(panel);
    if (focusable.length) focusable[0].focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-open]').forEach(function (iconWrap) {
      var badge = iconWrap.querySelector('[data-cart-count]');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'fabpad-nav__cart-badge';
          badge.setAttribute('data-cart-count', '');
          iconWrap.appendChild(badge);
        }
        badge.textContent = String(count);
        badge.hidden = false;
      } else if (badge) {
        badge.remove();
      }
    });

    document.querySelectorAll('.fabpad-nav__cart-badge').forEach(function (badge) {
      if (count > 0) {
        badge.textContent = String(count);
        badge.hidden = false;
      } else {
        badge.remove();
      }
    });

    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    if (countEl) {
      countEl.textContent = '(' + count + ' item' + (count === 1 ? '' : 's') + ')';
    }
  }

  function fetchCart() {
    return fetch(root + 'cart.js').then(function (res) {
      return res.json();
    });
  }

  function animateShippingBar() {
    if (!inner) return;
    var fill = inner.querySelector('[data-shipping-fill]');
    if (!fill) return;
    var target = fill.style.width;
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = target;
      });
    });
  }

  function refreshDrawer() {
    var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId);
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html || !inner) return fetchCart();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-cart-drawer-inner]');
        if (newInner) {
          inner.innerHTML = newInner.innerHTML;
        }
        return fetchCart();
      })
      .then(function (cart) {
        updateCartUI(cart);
        animateShippingBar();
        return cart;
      });
  }

  function updateCartUI(cart) {
    updateHeaderCount(cart.item_count);
    personalizeFbtUnderwear(cart);
  }

  function cartChange(lineKey, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart change failed');
        return res.json();
      })
      .then(function () { return refreshDrawer(); });
  }

  function cartAdd(variantId, quantity) {
    quantity = quantity || 1;
    return cartAddItems([{ id: variantId, quantity: quantity }]);
  }

  function cartAddItems(items) {
    var payload = Array.isArray(items) && items.length && typeof items[0] === 'object'
      ? items
      : (items || []).map(function (id) {
          return { id: id, quantity: 1 };
        });
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () { return refreshDrawer(); });
  }

  function afterAdd(payload, options) {
    options = options || {};
    return refreshDrawer().then(function (cart) {
      if (options.skipNudge) return cart;
      if (window.FabpadNudge && typeof window.FabpadNudge.show === 'function') {
        window.FabpadNudge.show(payload, cart);
      }
      return cart;
    });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab') {
      var focusable = getFocusable(panel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  drawer.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var key = qtyBtn.dataset.lineKey;
      var qty = parseInt(qtyBtn.dataset.qty, 10);
      if (qty < 0) qty = 0;
      cartChange(key, qty);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-line]');
    if (removeBtn) {
      cartChange(removeBtn.dataset.lineKey, 0);
      return;
    }

    var fbtAddAll = e.target.closest('[data-fbt-add-all]');
    if (fbtAddAll) {
      var ids = (fbtAddAll.dataset.variantIds || '')
        .split(',')
        .map(function (id) { return parseInt(id, 10); })
        .filter(function (id) { return id > 0; });
      if (!ids.length) return;
      fbtAddAll.disabled = true;
      cartAddItems(ids).finally(function () {
        fbtAddAll.disabled = false;
      });
      return;
    }

    var crossSellAdd = e.target.closest('[data-cross-sell-add]');
    if (crossSellAdd) {
      crossSellAdd.disabled = true;
      cartAdd(crossSellAdd.dataset.variantId, 1).finally(function () {
        crossSellAdd.disabled = false;
      });
      return;
    }

    var emptyCta = e.target.closest('[data-cart-empty-cta]');
    if (emptyCta) {
      closeDrawer();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    var formData = new FormData(form);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (data) { return afterAdd(data); })
      .catch(function () {
        form.submit();
      });
  });

  window.FabpadCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    fetchCart: fetchCart,
    updateCartUI: updateCartUI,
    afterAdd: afterAdd
  };

  document.addEventListener('fabpad:cart:updated', function (event) {
    var detail = event.detail || {};
    refreshDrawer().then(function (cart) {
      if (detail.openCart) {
        openDrawer();
        return;
      }
      if (detail.skipNudge) return;
      if (window.FabpadNudge && typeof window.FabpadNudge.show === 'function' && detail.payload) {
        window.FabpadNudge.show(detail.payload, cart);
      }
    });
  });

  recordViewedUnderwear();
  fetchCart().then(function (cart) {
    updateCartUI(cart);
  }).catch(function () {});
})();
